import * as types from '../mutations'

import TransactionService from '@/services/TransactionService'

const state = {
  selectedTransactionId: null,
  search: '',
  transactions: [],
  count: 0,
  loading: true
}

const getters = {
  selectedTransactionId: (state) => state.selectedTransactionId,
  transactions: (state) => state.transactions,
  count: (state) => state.count,
  loading: (state) => state.loading,
  getByExtendedId: (state) => (extendedId) => {
    let txns = state.transactions
    return txns.filter(t => t.code.extendedId == extendedId)
  },
}

const actions = {
  selectTransaction ({ commit }, { transactionId }) {
    commit(types.SELECT_TRANSACTION, transactionId)
  },

  clearTransactionSelection ({ commit }) {
    commit(types.CLEAR_TRANSACTION_SELECTION)
  },

  async searchTransaction ({ commit, getters }, search) {
    commit(types.SET_SEARCH, search)
    commit(types.TRANSACTION_LOADING)
    const transactions = getters.transactions
      .filter(txn => txn.code.extendedId.includes(search) || txn.code.serialNumber.includes(search))
    commit(types.SET_TRANSACTION_LIST, transactions)
    commit(types.TRANSACTION_LOADED)
  },

  async createTransaction ({ rootGetters, dispatch }, {extendedId, update}) {
    const code = await dispatch('codes/fetchByExtendedId', extendedId, {root: true})
    if (!code) throw new Error('Couldnt find code with id ' + extendedId)
    const {campaign} = code
    const scmFields = rootGetters['scmFields/scmFields'][campaign].map(field => field.key)
    await TransactionService.createTransaction({update, codeData: {
      campaign,
      extendedId,
      serialNumber: code['serial_number'],
    }, scmFields})
    await dispatch('loadTransactionList')
    await dispatch('codes/loadCodeList', null, {root: true})
  },

  async verifyTransaction ({ dispatch }, txId) {
    await TransactionService.verifyTransaction(txId)
    await dispatch('loadTransactionList')
  },

  async submitTransaction ({ dispatch }, txId) {
    await TransactionService.submitTransaction(txId)
    await dispatch('loadTransactionList')
  },

  async rejectTransaction ({ dispatch }, txId) {
    await TransactionService.rejectTransaction(txId)
    await dispatch('loadTransactionList')
  },

  async deleteTransaction ({ dispatch }, txId) {
    await TransactionService.deleteTransaction(txId)
    await dispatch('loadTransactionList')
  },

  async loadTransactionList ({ commit }) {
    commit(types.TRANSACTION_LOADING)
    let transactions = await TransactionService.loadTransactions()
    commit(types.SET_TRANSACTION_LIST, transactions)
    commit(types.TRANSACTION_LOADED)
  }
}

const mutations = {
  [types.SET_SEARCH] (state, search) {
    state.search = search
  },

  [types.SELECT_TRANSACTION] (state, id) {
    state.selectedTransactionId = id
  },

  [types.CLEAR_TRANSACTION_SELECTION] (state) {
    state.selectedTransactionId = null
  },

  [types.SET_TRANSACTION_LIST] (state, transactions) {
    state.transactions = transactions
  },

  [types.TRANSACTION_LOADING] (state) {
    state.loading = true
  },

  [types.TRANSACTION_LOADED] (state) {
    state.loading = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
